import { BerthReservation as ServerBerthReservation, BerthReservationOptions } from 'server/models/BerthReservation';
import { BerthReservationStatus, VesselSide } from 'server/enums/BerthReservation';
import { EndMark } from './EndMark';
import { IssueSeverity } from 'server/enums/Issue';
import { PierMark } from './PierMark';
import { NullableMeasurement } from './Measurement';

export { BerthReservationData, BerthReservationOptions } from 'server/models/BerthReservation';

export class BerthReservation extends ServerBerthReservation {
    PierMark : PierMark;

    constructor();
    constructor(data : BerthReservationOptions);
    constructor(data : BerthReservationOptions | null = null) {
        super(data || { Id: 0});

        this.PierMark = new PierMark(this.Footmark, () => this.Berth());
    }

    // aah: we re-create the EndMark object on each access so that we can capture the 'this' instance used to access it.
    // this is important b/c the access may have been to a BerthReservation draft object which may have overridden 
    // the original instance's signals with draft signals, and we want EndMark to reference those draft signals
    // not the underlying model's signals.
    // TODO: we should be able to move PierMark to the same process, but that would take further review, as its
    // usage is more embedded than EndMark.
    get EndMark() {
        return new EndMark(this);
    }

    Berth() { 
        let pt = this.Itinerary(), 
            loc = pt && pt.Location(); 
        return loc && loc.Berth(); 
    }

    PortCall() { return this.Itinerary() && this.Itinerary()!.PortCall(); }

    Status() {
        // Status field is derived from other fields
        return this.CancelledDate() !== null ? BerthReservationStatus.Cancelled :
               this.ConflictCount() > 0      ? BerthReservationStatus.Conflicted :
               this.ApprovedDate() !== null  ? BerthReservationStatus.Booked :
               BerthReservationStatus.Requested;
    }

    Bookable() {
        // TODO: This isn't entirely accurate. The check on issue severity depends upon Issues being loaded.
        // proposal: switch from persisting ConflictCount to MaxIssueSeverity, which will let us calculate both Status and Bookable
        return (this.Status() === BerthReservationStatus.Requested || this.Status() === BerthReservationStatus.Conflicted)
            && this.Issues().every(i => i.Severity() < IssueSeverity.Error);
    }

    Unbookable() {
        return this.Status() === BerthReservationStatus.Booked;
    }

    Cancellable() {
        return this.Status() !== BerthReservationStatus.Cancelled;
    }

    /**
     * Calculate the reservation length for the given inputs.
     * @param vesselLength The vessel length, or null if this reservation is length-only
     * @param vesselBeam The vessel beam, or null if this reservation is length-only
     * @param lengthOnlyLength The length of this length-only reservation, or null if this
     * reservation has a known vessel.
     * @param sideTo The reservation's SideTo value.
     * @param uom The target UOM.
     */
    static calculateLength(
        vesselLength : NullableMeasurement | null,
        vesselBeam : NullableMeasurement | null,
        lengthOnlyLength : NullableMeasurement | null,
        sideTo : VesselSide,
        uom : string
    ) {
        const source = (lengthOnlyLength?.Num() ?? null) === null ?
            sideTo === VesselSide.SternTo ?
                vesselBeam :
                vesselLength :
            // For length-only reservations, use the user-provided length regardless of sideTo
            lengthOnlyLength;
        return source?.convert(uom) ?? null;
    }
}



// WEBPACK FOOTER //
// ./data/models/BerthReservation.ts